var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.features.length
    ? _c("div", { staticClass: "home-features" }, [
        _c("h3", [_vm._v("Great Stories Start Here")]),
        _vm._v(" "),
        _c("div", { staticClass: "home-features-box" }, [
          _c(
            "div",
            { staticClass: "home-features-options" },
            _vm._l(_vm.features, function(feature) {
              return _c(
                "div",
                {
                  staticClass: "home-features-option",
                  class: { active: _vm.activeSection == feature },
                  on: {
                    click: function($event) {
                      return _vm.setActiveSection(feature)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon",
                    domProps: {
                      innerHTML: _vm._s(_vm.getSvg(feature.site_category))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "caption" }, [
                    _vm._v(
                      "\n                   " +
                        _vm._s(_vm.labels[feature.site_category]) +
                        "\n               "
                    )
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "home-features-selection" }, [
            _c("div", { staticClass: "home-feature-text" }, [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.activeSection.body) }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "learn-more",
                  attrs: {
                    href: _vm.activeSection.link.url,
                    target: _vm.activeSection.link.target
                  }
                },
                [_vm._v(_vm._s(_vm.activeSection.link.text))]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/HomeFeatures.vue?vue&type=template&id=5cadf2da&
// module id = 361
// module chunks = 0